export const useEnvironment = () => {
  const config = {
    URL_BACKEND: process.env.REACT_APP_URL_BACKEND,
    URL_TOTVS: process.env.REACT_APP_URL_TOTVS,
    DEBUG: process.env.REACT_APP_DEBUG,
    TITLE: process.env.REACT_APP_TITLE,
    GATEWAY_API_KEY: process.env.REACT_APP_GATEWAY_API_KEY,
    NODE_ENVIRONMENT: process.env.NODE_ENV,
    API_TOKEN: process.env.REACT_APP_API_TOKEN,
    API_GRAPHQL: process.env.REACT_APP_API_GRAPHQL,
    API_NODE: process.env.REACT_APP_API_NODE
  };

  return config;
};
